import React,{useEffect, useState,Suspense } from 'react' 
import { useAppContext } from "../Context/Store";
import {Link} from "react-router-dom"
//import Breadcrumb from "../components/Layout/BreadCrumb";
const Breadcrumb = React.lazy(() => import('../components/Layout/BreadCrumb'));

// Filter by categories
// const CategoryFilter = () => {
//   // Initial category data
//   const categories = [
//     {
//       mainCategory: "Electronics",
//       subcategories: [
//         { name: "Mobile", id: 1 },
//         { name: "Laptop", id: 2 },
//         { name: "Headphones", id: 3 }
//       ]
//     },
//     {
//       mainCategory: "Clothing",
//       subcategories: [
//         { name: "Shirts", id: 4 },
//         { name: "Pants", id: 5 }
//       ]
//     },
//     {
//       mainCategory: "Home Appliances",
//       subcategories: [
//         { name: "Washing Machine", id: 6 },
//         { name: "Refrigerator", id: 7 }
//       ]
//     }
//   ];

//   // State to track selected category
//   const [selectedCategory, setSelectedCategory] = useState(null);

//   // Function to handle main category change
//   const handleCategoryChange = (category) => {
//     setSelectedCategory(category);
//   };

//   return (
//     <div>
//       <h1>Filter Subcategories by Main Category</h1>
      
//       <div>
//         <h3>Select a Main Category</h3>
//         <ul>
//           {categories.map((category, index) => (
//             <li key={index}>
//               <button onClick={() => handleCategoryChange(category)}>
//                 {category.mainCategory}
//               </button>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {selectedCategory && (
//         <div>
//           <h3>{selectedCategory.mainCategory} Subcategories</h3>
//           <ul>
//             {selectedCategory.subcategories.map((subcategory) => (
//               <li key={subcategory.id}>{subcategory.name}</li>
//             ))}
//           </ul>
//           <p>Total Subcategories: {selectedCategory.subcategories.length}</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CategoryFilter;

export default function Customized({ sendBodyClass }) {

    const [dropdown, setdropdown] = useState(false);

    const { isError, isLoading, CustomizedData, domainURL, domainURLCMS } = useAppContext();

    const handleDropdownClick = () => {

        if(!dropdown)
          setdropdown(true);
        else
          setdropdown(false);
      };

      function CategoryLoad(){
        const items = document.querySelectorAll(".category-list li a");
        const products = document.querySelectorAll(".products article");

        items.forEach((item) => {
          // Active
          item.addEventListener("click", () => {
            items.forEach((item) => {
              item.classList.remove("active");
            });
            item.classList.add("active");

            // Filter
            const valueAttr = item.getAttribute("data-category");
            const valueText = item.innerHTML;
            products.forEach((item,index) => {
              item.style.display = "none";
              if (
                item.getAttribute("data-category").toLowerCase() ==
                  valueAttr.toLowerCase() ||
                  valueAttr == "all"
              ) {
                //document.querySelectorAll(".products article").style.display = "none";
                item.style.display = "block";
                //document.querySelector(".category-list").classList.remove("open");
                //document.querySelector(".filter-btn").text = valueText;
              }
            });
          });
        });
      }

      useEffect(() => { 
        sendBodyClass(false);
        CategoryLoad();
      },[CategoryLoad()])
   

    const CategoryArray = CustomizedData?.items?.filter((value, index, self) =>
        index === self.findIndex((t) => (
            t?.properties?.categoryCaption === value?.properties?.categoryCaption
        ))
    )



   

  return (
    <>
    <Suspense fallback={<div>Loading...</div>}>  
      <Breadcrumb 
        mainitemNameVal={`Customized`} 
        mainitemNameValLink={``} 
        itemNameVal={``} 
        itemNameValId={``} 
        subitemNameVal={``} 
      />
      <section className="products-box">
        <div className="inner">
            <h2>All <span>Customized</span> Products</h2>
            <div className="filter">
                <a className="filter-btn" onClick={handleDropdownClick}>Filter by category</a>
                <ul className={`category-list ${dropdown ?'open':''}`}>
                    {/* <li><a data-category="all">All</a></li> */}
<span className='arup'>&#129169;</span> 
                    {Array.isArray(CategoryArray) && CategoryArray.map((item, index) => {
                      const idValue = index;
 
return (
    <li key={item?.id || idValue} onClick={handleDropdownClick}><a data-category={item?.properties?.categoryCaption != null ? item?.properties?.categoryCaption.replace(' ', '-') : ""}>{item?.properties?.categoryText != null ? item?.properties?.categoryText : ""} </a></li>
  );
                    })
                }
                   
                </ul>
            </div>
            <article>
                <div className="products customizedpage">
                {Array.isArray(CustomizedData?.items) && CustomizedData?.items.map((item, index) => {
                  const idValue = index;
return (
    <article key={item?.id || idValue} data-category={item?.properties?.categoryCaption != null ? item?.properties?.categoryCaption.replace(' ', '-') : ""}>
    <Link to={`/customized/${item?.id}`}>

    {Array.isArray(item?.properties?.thumbnail) && item?.properties?.thumbnail.map((itemChild) => {
                      // Use a combination of parent item and child index for the key
                      

                      return (
                        <figure key={itemChild?.id || `${idValue}-${itemChild.id}`}>
                        <img alt={`${item?.properties?.thumbnailAlt}`}  src={`${domainURLCMS}/${itemChild?.url}`} />
                        <span className="arrow animate"></span>
                    </figure>
                      );
                    })
                }
       
        <aside>
            <div>
                <label>{item?.properties?.categoryCaption}</label>
                <h2>{item?.properties?.titleText}</h2>
            </div>
        </aside>
    </Link>
</article>
  );

                })
            }

                </div>
            </article>
        </div>
    </section>
    </Suspense>
    </>
  )
}
